export const COMPANY_ID_INTERHYP = '3';
